var React = require('react');

function AllGreenInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-713.459 -386.183)"},[React.createElement("path",{"d":"M765.59,425.323a8,8,0,0,1-4.01,6.934l-18.065,10.392a8,8,0,0,1-7.98,0l-18.066-10.4a8,8,0,0,1-4.01-6.934v-20.74a8,8,0,0,1,4.01-6.934l18.065-10.392a8,8,0,0,1,7.98,0l18.066,10.392a8,8,0,0,1,4.01,6.934Z","fill":"#04d0b0","key":0}),React.createElement("path",{"d":"M745.662,405.248A11.508,11.508,0,1,0,751,414.274","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M749,408.939l-9.577,9.577-4.281-4.281","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2","key":2})]));
}

AllGreenInline.defaultProps = {"width":"52.131","height":"57.531","viewBox":"0 0 52.131 57.531"};

module.exports = AllGreenInline;

AllGreenInline.default = AllGreenInline;
